export const thresholdImageColors = (base64image) => {
  const threshold = 123; // 0..255
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const image = new Image();

  image.src = base64image;

  return new Promise(resolve => {
    image.onload = function() {
      canvas.width = this.width;
      canvas.height = this.height;

      ctx.drawImage(this, 0, 0, this.width, this.height);

      const imgdata = ctx.getImageData(0, 0, this.width, this.height);

      for (let i = 0; i < imgdata.data.length; i += 4) { // 4 is for RGBA channels
        // R=G=B=R>T?255:0
        imgdata.data[i] = imgdata.data[i+1] = imgdata.data[i+2] = imgdata.data[i+1] > threshold ? 255 : 0;
      }

      ctx.putImageData(imgdata, 0, 0);

      resolve(canvas.toDataURL());
    };
  });
};
